export default {
  honourHistory: '/honour/client/history' // 进出记录
}
